// 動きの共通部品（ADR 0034）。端末の「視差効果を減らす」設定を尊重する。
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const query = () => (typeof window !== 'undefined' && window.matchMedia
  ? window.matchMedia('(prefers-reduced-motion: reduce)')
  : null);

export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(() => !!query()?.matches);
  useEffect(() => {
    const mq = query();
    if (!mq) return undefined;
    const on = () => setReduced(mq.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  return reduced;
}

/**
 * 並び順が変わった行を、前の位置から今の位置へ滑らせる（FLIP）。#246 の順位入れ替えで使う。
 * keys は行の識別子の並び。refs.current[key] に行の DOM を入れておく。
 */
export function useFlip(keys, refs, { duration = 600, reduced = false } = {}) {
  const prev = useRef(new Map());
  const sig = keys.join('|');
  useLayoutEffect(() => {
    const next = new Map();
    keys.forEach(k => { const el = refs.current[k]; if (el) next.set(k, el.getBoundingClientRect().top); });
    if (!reduced) {
      next.forEach((top, k) => {
        const before = prev.current.get(k);
        const el = refs.current[k];
        if (before == null || !el || before === top) return;
        el.animate(
          [{ transform: `translateY(${before - top}px)` }, { transform: 'translateY(0)' }],
          { duration, easing: 'cubic-bezier(.2,.8,.2,1)' }
        );
      });
    }
    prev.current = next;
  }, [sig, reduced, duration]);
}
